<div class="org-switcher dropdown" ngbDropdown>
  <button
    class="org-switcher-toggle dropdown-toggle arrow-none w-100"
    ngbDropdownToggle
    type="button"
  >
    @if (activeCompany) {
      <span class="org-switcher-avatar">{{
        initials(activeCompany.designacao)
      }}</span>
      <span class="org-switcher-name text-truncate">{{
        activeCompany.designacao
      }}</span>
    } @else {
      <span class="org-switcher-name text-truncate">Select a company</span>
    }
    <i class="iconoir-nav-arrow-down org-switcher-caret"></i>
  </button>
  <div class="dropdown-menu org-switcher-menu" ngbDropdownMenu>
    <small class="text-muted px-2 pb-1 d-block">Switch company</small>
    @for (company of companies; track company.id) {
      <a
        class="dropdown-item d-flex align-items-center"
        [class.active]="company.id === activeCompanyId"
        href="javascript:void(0);"
        (click)="selectCompany(company.id)"
      >
        <span class="org-switcher-avatar org-switcher-avatar-sm">{{
          initials(company.designacao)
        }}</span>
        <span class="text-truncate">{{ company.designacao }}</span>
        @if (company.id === activeCompanyId) {
          <i class="iconoir-check ms-auto"></i>
        }
      </a>
    }
    <div class="dropdown-divider"></div>
    <a class="dropdown-item" routerLink="/companies">View all companies</a>
  </div>
</div>
